import React from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import Loader from "../../Component/Loader";
import { toast } from "react-toastify";

function isValidEmail(email) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}

const nonNumericRegex = /^[A-Za-z\s]+$/;

const ContactUs = () => {
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [inputData, setInputData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: "",
    isAccept: false,
  });
  const [inputDataError, setInputDataError] = useState({
    firstName: false,
    lastName: false,
    email: false,
    phoneNumber: false,
    message: false,
    isAccept: false,
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!inputData?.firstName) {
      setInputDataError({ ...inputDataError, firstName: true });
      toast.error("Please Enter a First Name");
    } else if (inputData?.firstName?.length < 3) {
      toast.error("Please Enter a minimum 3 Characteristics");
      setInputDataError({ ...inputDataError, firstName: true });
    } else if (!inputData?.lastName) {
      setInputDataError({ ...inputDataError, lastName: true });
      toast.error("Please Enter a Last Name");
    } else if (inputData?.lastName?.length < 3) {
      toast.error("Please Enter a minimum 3 Characteristics");
      setInputDataError({ ...inputDataError, lastName: true });
    } else if (!inputData?.email) {
      setInputDataError({ ...inputDataError, email: true });
      toast.error("Please Enter a Email");
    } else if (!isValidEmail(inputData?.email)) {
      setInputDataError({ ...inputDataError, email: true });
      toast.error("Please Enter a Email in Proper Format");
    } else if (!inputData?.phoneNumber) {
      toast.error("Please Enter a Phone Number");
      setInputDataError({ ...inputDataError, phoneNumber: true });
    } else if (inputData?.phoneNumber?.length !== 10) {
      setInputDataError({ ...inputDataError, phoneNumber: true });
      toast.error("Please Enter a Phone Number in Correct Format!");
    } else if (!inputData?.message) {
      setInputDataError({ ...inputDataError, message: true });
      toast.error("Please Enter a Message");
    } else if (inputData?.message?.length < 3) {
      toast.error("Please Enter a minimum 3 Characteristics");
      setInputDataError({ ...inputDataError, message: true });
    } else if (!inputData?.isAccept) {
      toast.error("Please Check the Accept Terms & Condition");
    } else {
      let ipAddress = localStorage.getItem("ipAddress");

      setloading(true);
      let formData = new FormData();

      formData.append("clientId", process.env.REACT_APP_Client_Id);
      formData.append("firstName", inputData?.firstName);
      formData.append("lastName", inputData?.lastName);
      formData.append("email", inputData?.email);
      formData.append("phone", inputData?.phoneNumber);
      formData.append("message", inputData?.message);

      const requestOptions = {
        method: "POST",
        body: formData,
      };
      fetch(
        `${process.env.REACT_APP_API_URL}addcontactus?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            setloading(false);
            navigate("/");
            toast.success("Record Added Successfully.");
          } else {
            setloading(false);
            toast.error(data?.message);
          }
        })
        .catch((error) => {
          console.log("error: ", error);
          setloading(false);
          toast.error("There was an error, Please try again later.");
        });
    }
  };

  if (loading) return <Loader />;

  return (
    <>
      <Breadcrumb
        mainTitle={"Contact Us"}
        title={"Contact Us"}
        subTitle={"Home"}
      />

      <div id="main">
        <div class="wdt-elementor-container-fluid">
          <div
            data-elementor-type="wp-page"
            data-elementor-id="178"
            class="elementor elementor-178"
          >
            <section
              class="custom-slider-home-2 elementor-section elementor-top-section elementor-element elementor-element-74465d9 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="74465d9"
              data-element_type="section"
              data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
            >
              <div class="elementor-container elementor-column-gap-no">
                <div
                  class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ceda548"
                  data-id="ceda548"
                  data-element_type="column"
                >
                  <div class="elementor-widget-wrap elementor-element-populated">
                    <div
                      class="elementor-element elementor-element-578eebd start before-title  elementor-widget elementor-widget-wdt-heading"
                      data-id="578eebd"
                      data-element_type="widget"
                      data-settings='{"item_align":"start","split_heading":"true","wdt_enable_inview_status":"true","_animation":"fadeInUp","_animation_delay":200,"header_decorative_elements_icon_align":"before-title","title_vertical_align":"center","subtitle_vertical_align":"center","wdt_animation_effect":"none"}'
                      data-widget_type="wdt-heading.default"
                    >
                      <div class="elementor-widget-container">
                        <div
                          class="wdt-heading-holder  wdt-heading-wrapper-start"
                          id="wdt-heading-578eebd"
                        >
                          <div class="wdt-heading-subtitle-wrapper wdt-heading-align-center wdt-heading-deco-wrapper">
                            <span class="wdt-heading-subtitle">
                              <span class="wdt-heading-deco-inner wdt-left-part">
                                <span class="wdt-heading-deco-icon">
                                  <span class="wdt-content-icon-wrapper">
                                    <span class="wdt-content-icon">
                                      <span>
                                        <i>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 100 100"
                                          >
                                            <path d="M50,99L1,50L50,1l49,49L50,99z"></path>
                                          </svg>
                                        </i>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                              Contact Us
                              <span class="wdt-heading-deco-inner wdt-right-part"></span>
                            </span>
                          </div>
                          <h2 class="wdt-heading-title-wrapper wdt-heading-align-center ">
                            <span class="wdt-heading-title">
                              <span class="wdt-split-heading-wrapper">
                                <span class="wdt-split-heading-title">C</span>
                                <span class="wdt-split-heading-title">o</span>
                                <span class="wdt-split-heading-title">m</span>
                                <span class="wdt-split-heading-title">p</span>
                                <span class="wdt-split-heading-title">a</span>
                                <span class="wdt-split-heading-title">n</span>
                                <span class="wdt-split-heading-title">y</span>
                              </span>
                              <span class="wdt-split-heading-wrapper">
                                <span class="wdt-split-heading-title">H</span>
                                <span class="wdt-split-heading-title">e</span>
                                <span class="wdt-split-heading-title">a</span>
                                <span class="wdt-split-heading-title">d</span>
                                <span class="wdt-split-heading-title">q</span>
                                <span class="wdt-split-heading-title">u</span>
                                <span class="wdt-split-heading-title">a</span>
                                <span class="wdt-split-heading-title">r</span>
                                <span class="wdt-split-heading-title">t</span>
                                <span class="wdt-split-heading-title">e</span>
                                <span class="wdt-split-heading-title">r</span>
                                <span class="wdt-split-heading-title">s</span>
                              </span>
                            </span>
                          </h2>
                        </div>{" "}
                      </div>
                    </div>
                    <div
                      class="elementor-element elementor-element-3c69e43 start wdt-cus-contact-iconbox-section start start elementor-widget-tablet__width-inherit elementor-widget-mobile__width-inherit  elementor-widget elementor-widget-wdt-advanced-slider"
                      data-id="3c69e43"
                      data-element_type="widget"
                      data-settings='{"columns":"4","columns_laptop":"4","columns_tablet_extra":"3","item_align":"start","columns_mobile_extra":"2","item_align_mobile_extra":"start","columns_tablet":"3","item_align_mobile":"start","_animation_delay":300,"_animation":"fadeInUp","columns_mobile":1,"carousel_arrows_prev_arrow_vertical_align":"flex-start","carousel_arrows_prev_arrow_vertical_top_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_align":"flex-start","carousel_arrows_next_arrow_vertical_top_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_mobile":{"unit":"%","size":"","sizes":[]},"wdt_animation_effect":"none"}'
                      data-widget_type="wdt-advanced-slider.default"
                    >
                      <div class="elementor-widget-container">
                        <div
                          class="wdt-advanced-slider-holder wdt-content-item-holder wdt-column-holder "
                          id="wdt-advanced-slider-3c69e43"
                          data-settings=""
                        >
                          <div
                            class="wdt-column-wrapper wdt-column-gap-custom wdt-snap-scroll-enabled"
                            data-column-settings='{"columnDevices":["tablet_extra","tablet","mobile_extra","mobile"]}'
                            data-module-id="wdt-module-id-3c69e43"
                            id="wdt-module-id-3c69e43"
                          >
                            <div class="wdt-column">
                              <div class="wdt-content-item">
                                <div class="wdt-advanced-slider-block">
                                  <div class="wdt-image-icon-group">
                                    <div class="wdt-content-icon-wrapper ">
                                      <div class="wdt-content-icon">
                                        <Link
                                          to="/contact-us"
                                          class="silde_pop_vid"
                                        >
                                          <span>
                                            <i>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 40 40"
                                                style={{
                                                  enableBackground:
                                                    "new 0 0 40 40",
                                                }}
                                              >
                                                <g>
                                                  {" "}
                                                  <path d="M34,13.4C33.5,6.1,27.1,0,20,0h-0.1c-3.7,0-7.2,1.5-9.8,4.2C7.5,7,6,10.6,6,14.5c0,12.3,12.7,24.7,13.2,25.2  c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3C21.3,39.1,34,26.8,34,14.5C34,14.1,34,13.7,34,13.4L34,13.4z M20,21  c-3.5,0-6.3-2.9-6.3-6.5S16.5,8,20,8c3.5,0,6.3,2.9,6.3,6.5S23.5,21,20,21z"></path>
                                                </g>
                                              </svg>
                                            </i>
                                          </span>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="wdt-content-detail-group">
                                    <div class="wdt-content-title">
                                      <h5>
                                        <Link to="/contact-us">
                                          Our Address
                                        </Link>
                                      </h5>
                                    </div>
                                    <div class="wdt-content-description">
                                      FF1-Rudraksh Complex Opp. Darshanam Arise,
                                      Gotri – Sevasi Rd, Vadodara, Gujarat
                                      391101
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="wdt-column">
                              <div class="wdt-content-item">
                                <div class="wdt-advanced-slider-block">
                                  <div class="wdt-image-icon-group">
                                    <div class="wdt-content-icon-wrapper ">
                                      <div class="wdt-content-icon">
                                        <Link
                                          to="/contact-us"
                                          class="silde_pop_vid"
                                        >
                                          <span>
                                            <i>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 40 40"
                                                style={{
                                                  enableBackground:
                                                    "new 0 0 40 40",
                                                }}
                                              >
                                                <g>
                                                  {" "}
                                                  <path d="M38.9,36.3c1.6-1.6,1.4-4.3-0.5-5.7L32,25.8c-1.5-1.1-3.6-1-4.9,0.4L26,27.3c-0.1,0.1-0.3,0.2-0.4,0.3  c-0.5,0.5-1.3,0.7-2,0.4c-5.6-2.1-9.5-6-11.6-11.7c-0.3-0.7-0.1-1.5,0.4-2l0.2-0.2c0-0.1,0.1-0.1,0.1-0.2l1.1-1.1  c1.3-1.3,1.5-3.4,0.4-4.9L9.4,1.6C8-0.3,5.3-0.5,3.7,1.1L2.6,2.2C1.3,3.5,0.4,5.2,0.1,7C0.1,7.3,0,7.6,0,7.8  c-0.3,4.5,1.3,9.2,4.6,14.3c0.1,0.2,0.2,0.3,0.3,0.5c3.3,4.9,7.5,9.1,12.4,12.4c0.2,0.1,0.3,0.2,0.5,0.3c5.1,3.3,9.9,4.9,14.3,4.6  c0.3,0,0.5,0,0.8-0.1c1.8-0.3,3.5-1.1,4.8-2.4L38.9,36.3L38.9,36.3z"></path>{" "}
                                                  <path d="M40,19.1c-0.4-4.9-2.5-9.6-6-13.1c-3.5-3.5-8.1-5.6-13.1-6c-0.7-0.1-1.4,0.5-1.5,1.3C19.4,2,20,2.7,20.7,2.7  C25,3,29.1,4.9,32.1,7.9c3,3,4.9,7.1,5.2,11.3c0.1,0.7,0.6,1.3,1.4,1.3c0,0,0.1,0,0.1,0C39.5,20.5,40.1,19.8,40,19.1L40,19.1z"></path>{" "}
                                                  <path d="M28.9,12.1c-2.1-2.1-4.9-3.5-7.9-3.9c-0.8-0.1-1.5,0.4-1.6,1.2c-0.1,0.8,0.4,1.5,1.2,1.6c2.4,0.3,4.5,1.4,6.2,3.1  c1.7,1.7,2.8,3.9,3.1,6.2c0.1,0.7,0.7,1.2,1.4,1.2c0.1,0,0.1,0,0.2,0c0.8-0.1,1.3-0.8,1.2-1.6C32.4,16.9,31.1,14.2,28.9,12.1  L28.9,12.1z"></path>
                                                </g>
                                              </svg>
                                            </i>
                                          </span>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="wdt-content-detail-group">
                                    <div class="wdt-content-title">
                                      <h5>
                                        <Link to="/contact-us">Contact Us</Link>
                                      </h5>
                                    </div>
                                    <div class="wdt-content-button-group">
                                      <div class="wdt-content-button wdt-button-clone">
                                        <Link to="tel:+919825130190">
                                          <div class="wdt-button-text">
                                            <span>+ 91 9825130190</span>
                                          </div>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="wdt-column">
                              <div class="wdt-content-item">
                                <div class="wdt-advanced-slider-block">
                                  <div class="wdt-image-icon-group">
                                    <div class="wdt-content-icon-wrapper ">
                                      <div class="wdt-content-icon">
                                        <Link
                                          to="/contact-us"
                                          class="silde_pop_vid"
                                        >
                                          <span>
                                            <i>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 40 40"
                                                style={{
                                                  enableBackground:
                                                    "new 0 0 40 40",
                                                }}
                                              >
                                                <g>
                                                  {" "}
                                                  <path d="M8.2,30.8H3.4c-2-2.9-3.2-6.5-3.4-10.3h6.4C6.5,24.2,7.1,27.7,8.2,30.8L8.2,30.8z"></path>{" "}
                                                  <path d="M13.3,37.9c-3.2-1.1-6-2.9-8.2-5.1h4.4c0.4,0.7,0.7,1.4,1.2,2C11.5,36,12.4,37.1,13.3,37.9L13.3,37.9z"></path>{" "}
                                                  <path d="M35.9,32.8c-2.2,2.3-5,4-8.2,5.1c1-0.9,1.9-1.9,2.7-3.1c0.4-0.6,0.8-1.3,1.2-2H35.9L35.9,32.8z"></path>{" "}
                                                  <path d="M40,20.5c-0.2,3.8-1.4,7.3-3.4,10.3h-4.8c1.1-3.1,1.8-6.6,1.9-10.3H40z"></path>{" "}
                                                  <path d="M40,18.5h-6.4c-0.1-3.7-0.7-7.2-1.9-10.3h4.8C38.6,11.2,39.8,14.7,40,18.5z"></path>{" "}
                                                  <path d="M35.9,6.2h-4.4c-0.4-0.7-0.7-1.4-1.2-2C29.5,3,28.7,1.9,27.7,1C30.9,2.1,33.7,3.9,35.9,6.2L35.9,6.2z"></path>{" "}
                                                  <path d="M8.2,8.2c-1.1,3.1-1.8,6.6-1.9,10.3H0c0.2-3.8,1.4-7.3,3.4-10.3H8.2z"></path>{" "}
                                                  <path d="M13.3,1c-1,0.9-1.9,1.9-2.7,3.1c-0.4,0.6-0.8,1.3-1.2,2H5.1C7.3,3.9,10.2,2.1,13.3,1L13.3,1z"></path>{" "}
                                                  <path d="M30.8,20.5c-0.1,3.7-0.8,7.2-2,10.3h-8.3V20.5H30.8z"></path>{" "}
                                                  <path d="M18.5,20.5v10.3h-8.3c-1.2-3-1.9-6.5-2-10.3H18.5z"></path>{" "}
                                                  <path d="M18.5,32.8V40c-2.5-0.4-4.8-2.5-6.6-6c-0.2-0.4-0.4-0.8-0.6-1.2H18.5L18.5,32.8z"></path>{" "}
                                                  <path d="M27.7,32.8c-0.2,0.4-0.4,0.8-0.6,1.2c-1.8,3.5-4.1,5.6-6.6,6v-7.2H27.7L27.7,32.8z"></path>{" "}
                                                  <path d="M18.5,0v7.2h-7.2c0.2-0.4,0.4-0.8,0.6-1.2C13.7,2.5,16,0.4,18.5,0z"></path>{" "}
                                                  <path d="M27.7,7.2h-7.2V0c2.5,0.4,4.8,2.5,6.6,6C27.3,6.4,27.5,6.8,27.7,7.2L27.7,7.2z"></path>{" "}
                                                  <path d="M30.8,18.5H20.5V8.2h8.3C30,11.2,30.7,14.8,30.8,18.5z"></path>{" "}
                                                  <path d="M18.5,8.2v10.3H8.2c0.1-3.7,0.8-7.2,2-10.3H18.5z"></path>
                                                </g>
                                              </svg>
                                            </i>
                                          </span>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="wdt-content-detail-group">
                                    <div class="wdt-content-title">
                                      <h5>
                                        <Link to="/contact-us">
                                          Business Hour
                                        </Link>
                                      </h5>
                                    </div>
                                    <div class="wdt-content-description">
                                      Mon to Sun- 9am - 9pm 
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="wdt-column">
                              <div class="wdt-content-item">
                                <div class="wdt-advanced-slider-block">
                                  <div class="wdt-image-icon-group">
                                    <div class="wdt-content-icon-wrapper ">
                                      <div class="wdt-content-icon">
                                        <Link
                                          to="/contact-us"
                                          class="silde_pop_vid"
                                        >
                                          <span>
                                            <i>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 40 40"
                                                style={{
                                                  enableBackground:
                                                    "new 0 0 40 40",
                                                }}
                                              >
                                                <g>
                                                  {" "}
                                                  <path d="M15.4,18.3C15.4,18.3,15.4,18.3,15.4,18.3L15.4,18.3C15.4,18.4,15.4,18.4,15.4,18.3C15.4,18.4,15.4,18.4,15.4,18.3l1.5,1.4  c1.8,1.6,4.4,1.6,6.2,0l1.4-1.3l0.2-0.2l13-12c0.1-0.1,0-0.3-0.1-0.3H2.4C2.2,6,2.2,6.2,2.3,6.3L15.4,18.3  C15.4,18.3,15.4,18.3,15.4,18.3C15.4,18.3,15.4,18.3,15.4,18.3C15.4,18.3,15.4,18.3,15.4,18.3z"></path>{" "}
                                                  <path d="M0.2,8.3C0.1,8.2,0,8.2,0,8.4v23.2c0,0.1,0.2,0.2,0.2,0.1l7.9-8.2c2.3-2.3,2.1-6.1-0.2-8.2L0.2,8.3z"></path>{" "}
                                                  <path d="M20.8,24.9C20.8,24.9,20.8,24.9,20.8,24.9c-0.2,0.2-0.5,0.3-0.8,0.3c-0.3,0-0.6-0.1-0.8-0.3l-3.1-2.9  c-0.8-0.8-2.1-0.7-2.9,0.1L2.3,33.7c-0.1,0.1,0,0.3,0.1,0.3h35.3c0.1,0,0.2-0.2,0.1-0.3L26.8,22c-0.8-0.8-2.1-0.9-2.9-0.1  L20.8,24.9C20.8,24.9,20.8,24.9,20.8,24.9z"></path>{" "}
                                                  <path d="M40,8.1C40,8.1,40,8.1,40,8.1l-8.8,8c-1.9,1.8-2,4.8-0.2,6.6l8.7,9c0.1,0.1,0.2,0,0.2-0.1V8.4C40,8.3,40,8.2,40,8.1  C40,8.1,40,8.1,40,8.1z"></path>
                                                </g>
                                              </svg>
                                            </i>
                                          </span>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="wdt-content-detail-group">
                                    <div class="wdt-content-title">
                                      <h5>
                                        <Link to="/contact-us">
                                          Contact Support
                                        </Link>
                                      </h5>
                                    </div>
                                    <div class="wdt-content-button-group">
                                      <div class="wdt-content-button wdt-button-clone">
                                        <Link to="mailto:k9.vadodara@gmail.com">
                                          <div class="wdt-button-text">
                                            <span>k9.vadodara@gmail.com</span>
                                          </div>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="wdt-column-pagination wdt-snap-scroll-pagination">
                            <button class="wdt-pagination-prev wdt-module-id-3c69e43">
                              Previous
                            </button>
                            <button class="wdt-pagination-next wdt-module-id-3c69e43">
                              Next
                            </button>
                          </div>
                        </div>{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              class="custom-slider-home-2 elementor-section elementor-top-section elementor-element elementor-element-d2a79ff elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="d2a79ff"
              data-element_type="section"
              data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
            >
              <div class="elementor-container elementor-column-gap-no">
                <div
                  class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-45bafdf"
                  data-id="45bafdf"
                  data-element_type="column"
                >
                  <div class="elementor-widget-wrap elementor-element-populated">
                    <section
                      class="elementor-section elementor-inner-section elementor-element elementor-element-6a795dd elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                      data-id="6a795dd"
                      data-element_type="section"
                      data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
                    >
                      <div class="elementor-container elementor-column-gap-no">
                        <div
                          class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-21528a7"
                          data-id="21528a7"
                          data-element_type="column"
                        >
                          <div class="elementor-widget-wrap elementor-element-populated">
                            <div
                              class="elementor-element elementor-element-873b8cd start elementor-widget__width-initial  elementor-widget elementor-widget-wdt-heading"
                              data-id="873b8cd"
                              data-element_type="widget"
                              data-settings='{"item_align":"start","split_heading":"true","wdt_enable_inview_status":"true","_animation":"fadeInUp","_animation_delay":200,"title_vertical_align":"center","subtitle_vertical_align":"center","wdt_animation_effect":"none"}'
                              data-widget_type="wdt-heading.default"
                            >
                              <div class="elementor-widget-container">
                                <div
                                  class="wdt-heading-holder  wdt-heading-wrapper-start"
                                  id="wdt-heading-873b8cd"
                                >
                                  <h2 class="wdt-heading-title-wrapper wdt-heading-align-center wdt-heading-deco-wrapper">
                                    <span class="wdt-heading-title">
                                      <span class="wdt-split-heading-wrapper">
                                        <span class="wdt-split-heading-title">
                                          N
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          e
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          e
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          d
                                        </span>
                                      </span>
                                      <span class="wdt-split-heading-wrapper">
                                        <span class="wdt-split-heading-title">
                                          M
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          o
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          r
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          e
                                        </span>
                                      </span>
                                      <span class="wdt-split-heading-wrapper">
                                        <span class="wdt-split-heading-title">
                                          A
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          s
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          s
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          i
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          s
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          t
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          a
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          n
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          c
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          e
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          ?
                                        </span>
                                      </span>
                                      <span class="wdt-split-heading-wrapper">
                                        <span class="wdt-split-heading-title">
                                          E
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          m
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          a
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          i
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          l
                                        </span>
                                      </span>
                                      <span class="wdt-split-heading-wrapper">
                                        <span class="wdt-split-heading-title">
                                          U
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          s
                                        </span>
                                      </span>
                                      <span class="wdt-split-heading-wrapper">
                                        <span class="wdt-split-heading-title">
                                          V
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          i
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          a
                                        </span>
                                      </span>
                                      <span class="wdt-split-heading-wrapper">
                                        <span class="wdt-split-heading-title">
                                          T
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          h
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          i
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          s
                                        </span>
                                      </span>
                                      <span class="wdt-split-heading-wrapper">
                                        <span class="wdt-split-heading-title">
                                          F
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          o
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          r
                                        </span>
                                        <span class="wdt-split-heading-title">
                                          m
                                        </span>
                                      </span>
                                    </span>
                                  </h2>
                                  <div class="wdt-heading-content-wrapper">
                                   Whether you need interior solutions, custom furniture, premium hardware, or project consultation, our team is here to help.
                                    Connect with K9 Interior for expert guidance, quick support, and personalized service tailored to your space and style.
                                    dignissim.{" "}
                                  </div>
                                </div>{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-87b58a4"
                          data-id="87b58a4"
                          data-element_type="column"
                        >
                          <div class="elementor-widget-wrap elementor-element-populated">
                            <div
                              class="elementor-element elementor-element-0ca7127 elementor-widget elementor-widget-image"
                              data-id="0ca7127"
                              data-element_type="widget"
                              data-settings='{"wdt_animation_effect":"none"}'
                              data-widget_type="image.default"
                            >
                              <div class="elementor-widget-container">
                                <img
                                  fetchpriority="high"
                                  decoding="async"
                                  width="1200"
                                  height="340"
                                  src="https://furniforma.wpengine.com/wp-content/uploads/2024/12/Contact-us-formimg-01.png"
                                  class="attachment-full size-full wp-image-1848"
                                  alt=""
                                  srcset="https://furniforma.wpengine.com/wp-content/uploads/2024/12/Contact-us-formimg-01.png 1200w, https://furniforma.wpengine.com/wp-content/uploads/2024/12/Contact-us-formimg-01-300x85.png 300w, https://furniforma.wpengine.com/wp-content/uploads/2024/12/Contact-us-formimg-01-1024x290.png 1024w, https://furniforma.wpengine.com/wp-content/uploads/2024/12/Contact-us-formimg-01-768x218.png 768w, https://furniforma.wpengine.com/wp-content/uploads/2024/12/Contact-us-formimg-01-1000x283.png 1000w"
                                  sizes="(max-width: 1200px) 100vw, 1200px"
                                />{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <div
                      class="elementor-element elementor-element-de8a8c3 elementor-widget__width-initial  elementor-widget elementor-widget-shortcode"
                      data-id="de8a8c3"
                      data-element_type="widget"
                      data-settings='{"_animation":"fadeInUp","_animation_delay":300,"wdt_animation_effect":"none"}'
                      data-widget_type="shortcode.default"
                    >
                      <div class="elementor-widget-container">
                        <div class="elementor-shortcode">
                          <div
                            class="wpcf7 no-js"
                            id="wpcf7-f195-p178-o2"
                            lang="en-US"
                            dir="ltr"
                            data-wpcf7-id="195"
                          >
                            <div class="screen-reader-response">
                              <p
                                role="status"
                                aria-live="polite"
                                aria-atomic="true"
                              ></p>{" "}
                              <ul></ul>
                            </div>
                            <form
                              onSubmit={(e) => {
                                handleSubmit(e);
                              }}
                              class="wpcf7-form init wdt-cus-contact-page-form wdt-dark-bg"
                            >
                              <p>
                                <span class="wpcf7-form-control-wrap">
                                  <input
                                    size="40"
                                    maxlength="400"
                                    class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                    aria-required="true"
                                    style={{
                                      border:
                                        inputDataError?.firstName &&
                                        "1px solid red",
                                    }}
                                    aria-invalid="false"
                                    placeholder="First Name*"
                                    value={inputData?.firstName}
                                    onChange={(e) => {
                                      if (
                                        nonNumericRegex.test(e.target.value) ||
                                        e.target.value === ""
                                      ) {
                                        setInputData({
                                          ...inputData,
                                          firstName: e.target.value,
                                        });

                                        if (e.target.value?.length >= 3) {
                                          setInputDataError({
                                            ...inputDataError,
                                            firstName: false,
                                          });
                                        } else {
                                          setInputDataError({
                                            ...inputDataError,
                                            firstName: true,
                                          });
                                        }
                                      } else {
                                        toast.error("Type Characters Only", {
                                          toastId: "sysmbol",
                                        });
                                      }
                                    }}
                                    type="text"
                                  />
                                </span>
                                <span class="wpcf7-form-control-wrap">
                                  <input
                                    size="40"
                                    maxlength="400"
                                    class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                    aria-required="true"
                                    aria-invalid="false"
                                    placeholder="Last Name*"
                                    style={{
                                      border:
                                        inputDataError?.lastName &&
                                        "1px solid red",
                                    }}
                                    value={inputData?.lastName}
                                    onChange={(e) => {
                                      if (
                                        nonNumericRegex.test(e.target.value) ||
                                        e.target.value === ""
                                      ) {
                                        setInputData({
                                          ...inputData,
                                          lastName: e.target.value,
                                        });

                                        if (e.target.value?.length >= 3) {
                                          setInputDataError({
                                            ...inputDataError,
                                            lastName: false,
                                          });
                                        } else {
                                          setInputDataError({
                                            ...inputDataError,
                                            lastName: true,
                                          });
                                        }
                                      } else {
                                        toast.error("Type Characters Only", {
                                          toastId: "sysmbol",
                                        });
                                      }
                                    }}
                                    type="text"
                                  />
                                </span>
                                <span class="wpcf7-form-control-wrap">
                                  <input
                                    size="40"
                                    maxlength="400"
                                    class="wpcf7-form-control wpcf7-email wpcf7-validates-as-required wpcf7-text wpcf7-validates-as-email"
                                    aria-required="true"
                                    aria-invalid="false"
                                    style={{
                                      border:
                                        inputDataError?.email &&
                                        "1px solid red",
                                    }}
                                    placeholder="Email *"
                                    value={inputData?.email}
                                    onChange={(e) => {
                                      setInputData({
                                        ...inputData,
                                        email: e.target.value,
                                      });

                                      if (
                                        e.target.value?.length >= 3 &&
                                        isValidEmail(e.target.value)
                                      ) {
                                        setInputDataError({
                                          ...inputDataError,
                                          email: false,
                                        });
                                      } else {
                                        setInputDataError({
                                          ...inputDataError,
                                          email: true,
                                        });
                                      }
                                    }}
                                    type="email"
                                  />
                                </span>
                                <span class="wpcf7-form-control-wrap">
                                  <input
                                    size="40"
                                    maxlength="400"
                                    class="wpcf7-form-control wpcf7-tel wpcf7-validates-as-required wpcf7-text wpcf7-validates-as-tel"
                                    aria-required="true"
                                    style={{
                                      border:
                                        inputDataError?.phoneNumber &&
                                        "1px solid red",
                                    }}
                                    aria-invalid="false"
                                    placeholder="Contact Number*"
                                    value={inputData?.phoneNumber}
                                    onChange={(e) => {
                                      setInputData({
                                        ...inputData,
                                        phoneNumber: e.target.value,
                                      });

                                      if (e.target.value?.length === 10) {
                                        setInputDataError({
                                          ...inputDataError,
                                          phoneNumber: false,
                                        });
                                      } else {
                                        setInputDataError({
                                          ...inputDataError,
                                          phoneNumber: true,
                                        });
                                      }
                                    }}
                                    type="number"
                                  />
                                </span>

                                <span class="wpcf7-form-control-wrap">
                                  <textarea
                                    cols="40"
                                    rows="10"
                                    maxlength="2000"
                                    class="wpcf7-form-control wpcf7-textarea"
                                    aria-invalid="false"
                                    placeholder="Message Here"
                                    style={{
                                      border:
                                        inputDataError?.message &&
                                        "1px solid red",
                                    }}
                                    value={inputData?.message}
                                    onChange={(e) => {
                                      setInputData({
                                        ...inputData,
                                        message: e.target.value,
                                      });

                                      if (e.target.value?.length >= 3) {
                                        setInputDataError({
                                          ...inputDataError,
                                          message: false,
                                        });
                                      } else {
                                        setInputDataError({
                                          ...inputDataError,
                                          message: true,
                                        });
                                      }
                                    }}
                                  ></textarea>
                                </span>
                              </p>
                              <div class="wdt-cus-form-acpt-btn-group">
                                <p style={{ width: "max-content" }}>
                                  <span
                                    class="wpcf7-form-control-wrap"
                                    style={{ width: "max-content" }}
                                  >
                                    <span class="wpcf7-form-control wpcf7-acceptance optional">
                                      <span class="wpcf7-list-item">
                                        <label>
                                          <input
                                            type="checkbox"
                                            checked={inputData?.isAccept}
                                            onChange={(e) => {
                                              setInputData({
                                                ...inputData,
                                                isAccept: e.target.checked,
                                              });

                                              if (e.target.checked) {
                                                setInputDataError({
                                                  ...inputDataError,
                                                  isAccept: false,
                                                });
                                              } else {
                                                setInputDataError({
                                                  ...inputDataError,
                                                  isAccept: true,
                                                });
                                              }
                                            }}
                                            aria-invalid="false"
                                          />
                                          <span class="wpcf7-list-item-label">
                                            I Agree to terms &amp; Condition
                                          </span>
                                        </label>
                                      </span>
                                    </span>
                                  </span>
                                </p>
                                <div class="wdt-contact-form7-btn">
                                  <p>
                                    <input
                                      class="wpcf7-form-control wpcf7-submit has-spinner"
                                      type="submit"
                                      value="Send Message"
                                    />
                                  </p>
                                </div>
                              </div>
                              <div
                                class="wpcf7-response-output"
                                aria-hidden="true"
                              ></div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              class="elementor-section elementor-top-section elementor-element elementor-element-b2bb56e elementor-section-full_width elementor-section-height-default elementor-section-height-default "
              data-id="b2bb56e"
              data-element_type="section"
              data-settings='{"animation":"fadeInUp","animation_delay":200,"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
            >
              <div class="elementor-container elementor-column-gap-no">
                <div
                  class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d802773"
                  data-id="d802773"
                  data-element_type="column"
                >
                  <div class="elementor-widget-wrap elementor-element-populated">
                    <div
                      class="elementor-element elementor-element-08bedd7 elementor-align-left elementor-align-left elementor-widget elementor-widget-wdt-google-map"
                      data-id="08bedd7"
                      data-element_type="widget"
                      data-settings='{"wdt_animation_effect":"none"}'
                      data-widget_type="wdt-google-map.default"
                    >
                      <div class="elementor-widget-container">
                        <div
                          id="wdt-google-map-08bedd7"
                          class="wdt-google-map-wrapper"
                        >
                          <div
                            class="wdt-google-map"
                            data-options='{"mapTypeId":"roadmap","zoom":15,"streetViewControl":false,"mapTypeControl":false,"zoomControl":false,"fullscreenControl":false,"scaleControl":false,"rotateControl":false,"scrollwheel":false,"draggable":true,"styles":"[]","center":{"lat":51.5284738,"lng":-0.3826334}}'
                            data-markers='[{"key":"98c6c1e","latitude":"51.5284738","longitude":"-0.3826334","title":"London","desc":"","show_info_window":"yes","load_info_window":"click","marker_additional_details_type":"default","marker_additional_details_default":"","marker_additional_details_template":null,"icon":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/09\/Location-icon.svg","icon_size":50}]'
                            data-marker-animation="bounce"
                            data-iw-max-width="240"
                          >
                            <iframe
                              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d472449.10928748513!2d73.132004!3d22.315512!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc99236af81eb%3A0xbb96bad54fa290aa!2sK9%20Interior%20Pvt.%20Ltd.!5e0!3m2!1sen!2sus!4v1739937962566!5m2!1sen!2sus"
                              width="100%"
                              height="600"
                              style={{ border: 0 }}
                              allowfullscreen=""
                              loading="lazy"
                              referrerpolicy="no-referrer-when-downgrade"
                            ></iframe>
                          </div>
                        </div>{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
